import React, { useState } from "react";
import nominationStyle from "src/Assets/css/Moderator/Nominations.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import AvatarBadge from "src/Components/AvatarBadge";
import { styled } from "@mui/material/styles";
import API from "../../../network";

const NameContainer = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  marginLeft: "10px",
});

const UserName = styled("div")({
  fontSize: "14px",
  fontWeight: "700",
  color: "#333",
});

const NominationCard = ({ user, nominations, tenantId, onRemove }) => {
  const [isOpen, setIsOpen] = useState(false);

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  
  const handleNominationAction = async (status) => {
    try {
      const formData = new FormData();

      formData.append("nominatedId", user?.id);
      formData.append("nominatedstatus", status);
      formData.append("selectedTId", tenantId);
      formData.append("userId", user?.mainuserdata?.userid);

      const response = await API.nominateOrRemoveImpactFullMembers(formData);

      if (response?.status === 200 && response?.data?.status === "success") {
        onRemove(user?.mainuserdata?.userid);
      }
    } catch (error) {
      console.error("Nomination action failed:", error);
    }
  };

  const isPMUser =
    user?.mainuserdata?.isPM == 1 ||
    user?.isPM == 1 ||
    user?.mainuserdata?.is_primary_moderator == 1 ||
    user?.is_primary_moderator == 1;

  const isModUser =
    (user?.mainuserdata?.isModerator == 1 ||
      user?.isModerator == 1 ||
      user?.mainuserdata?.isModerator === "1" ||
      user?.isModerator === "1") &&
    !isPMUser;

  return (
    <div className={nominationStyle.nominationCard}>
      {/* User Header */}
      <div
        className={nominationStyle.nominationHeader}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={feedstyles.avatardetails}>
          <div>
            <AvatarBadge
              src={`${profileImagePath}${user?.uimage}`}
              className={feedstyles.avatar}
              variant="square"
              isPrimaryModerator={isPMUser}
              isModerator={isModUser}
            />
          </div>

          <NameContainer>
            <UserName>{user?.displayName}</UserName>

            <span
              className={nominationStyle.nominationCount}
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(!isOpen);
              }}
            >
              {user?.nominatedCount} nomination
              {user?.nominatedCount > 1 ? "s" : ""}
              <span className={nominationStyle.dropdownIcon}>
                {isOpen ? "▲" : "▼"}
              </span>
            </span>
          </NameContainer>

          {/* Existing hover card reused */}
          <div className={feedstyles.profileHoverContentContainer}>
            <div className={feedstyles.profilehoverimageandcount}>
              <div>
                <AvatarBadge
                  src={`${profileImagePath}${user?.uimage}`}
                  className={feedstyles.avatar}
                  variant="square"
                  isPrimaryModerator={isPMUser}
                  isModerator={isModUser}
                />
              </div>

              <div style={{ marginLeft: "8px" }}>
                <p className={feedstyles.profilehovername}>
                  {user?.displayName}
                </p>

                <p className={feedstyles.profilecount}>
                  ASK {user?.mainuserdata?.askcount ?? 0}
                  {" | "}
                  SAY {user?.mainuserdata?.saycount ?? 0}
                  {" | "}
                  UPDATE {user?.mainuserdata?.updatecount ?? 0}
                  {" | "}
                  TAG {user?.mainuserdata?.hashtagcount ?? 0}
                  {" | "}
                  Answers {user?.mainuserdata?.answercount ?? 0}
                  {" | "}
                  Replies {user?.mainuserdata?.replycount ?? 0}
                </p>
              </div>
            </div>

            <p className={feedstyles.profilehovercontent}>
              {user?.mainuserdata?.shortBio || ""}
            </p>
          </div>
        </div>
      </div>

      {/* Expanded Section */}
      {isOpen && (
        <div className={nominationStyle.nominationList}>
          {nominations?.map((nomination, index) => {
            return (
              <div
                key={nomination?.id || index}
                className={nominationStyle.nominationItem}
              >
                <AvatarBadge
                  src={`${profileImagePath}${nomination?.uimage}`}
                  className={feedstyles.avatar}
                  variant="square"
                  isPrimaryModerator={nomination?.mainuserdata?.isPM == 1}
                  isModerator={
                    nomination?.mainuserdata?.isModerator == 1 &&
                    nomination?.mainuserdata?.isPM == 0
                  }
                />

                <div className={nominationStyle.nominationContent}>
                  <p className={nominationStyle.nominatedByName}>
                    {nomination?.displayName}
                  </p>

                  <p className={nominationStyle.nominationDescription}>
                    {nomination?.description}
                  </p>

                  <div className={nominationStyle.nominationFooter}>
                    <span>{nomination?.created_date}</span>
                  </div>
                </div>
              </div>
            );
          })}
          <div className={nominationStyle.actionButtons}>
            <button
              className={nominationStyle.clearButton}
              type="button"
              onClick={() => handleNominationAction("dismiss")}
            >
              Clear All
            </button>

            <button
              className={nominationStyle.nominateButton}
              type="button"
              onClick={() => handleNominationAction("approve")}
            >
              Nominate
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NominationCard;
